<div class="sub-stepper">
  <app-import-file (uploadFileEvent)="uploadFile($event)"></app-import-file>
  <mat-spinner *ngIf="spinner && !jiraImportService.jiraErrors[0]"></mat-spinner>
</div>
